export const watchShipment = {
  sendText: "A domicilio",
  timeText: "24/48h",
};

export const permanentResidenceStep = {
  residence: "Indica tu domicilio",
};

export const MASKS = {
  phone: { maxLength: 9, separationLength: 3, separator: " " },
  accountNumber: { maxLength: 24, separationLength: 4, separator: " " },
};
